"use client";

import { fontWeights } from "@/utils/fonts";

interface ProjectResultProps {
  title?: string;
  resultText?: string;
  liveLink?: string;
  appLink?: string;
}

export const ProjectResult = ({ title = 'The Result', resultText, liveLink, appLink }: ProjectResultProps) => {
  return (
    <section className={`px-4 sm:px-6 bg-white ${!(liveLink || appLink) ? 'pb-2 sm:pb-4 md:pb-6 lg:pb-8 xl:pb-10' : ''}`}>
      {/* The Result Section */}
      {resultText && (
        <>
          <div className="w-full my-4 lg:my-6 xl:my-8">
            <div className="flex items-center px-3 sm:px-10 lg:px-[98px] py-1.5 sm:py-3 lg:py-4 bg-[#F1F4F7] rounded-[10px] text-[18px] lg:text-[22px] text-[#09155E] shadow-sm max-w-[1220px] mx-auto"
              style={{ fontFamily: "Inter", fontWeight: fontWeights.inter.bold }}>
              {title}
            </div>
          </div>

          <div className="max-w-[1020px] mx-auto">
            <p className="text-[15px] lg:text-[18px] leading-[20px] sm:leading-relaxed text-[#585B6F]" style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}>
              {resultText}
            </p>
          </div>
        </>
      )}

      {/* Visit Website and Download App */}
      {(liveLink || appLink) && (
        <div className="max-w-[1020px] mx-auto flex flex-wrap items-center justify-center gap-4 sm:gap-6 lg:gap-8 py-2 sm:my-4 md:my-6 lg:my-8 xl:my-10">
          {liveLink && (
            <a href={liveLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center px-4 sm:px-6 lg:px-8 py-2 sm:py-3 bg-[#005bb7] hover:bg-[#004a96] text-white rounded-full text-[12px] sm:text-[13px] lg:text-[14px] xl:text-[16px] transition-all shadow-md"
              style={{ fontFamily: "Inter", fontWeight: fontWeights.inter.bold }}>Visit Website</a>
          )}
          {appLink && (
            <a href={appLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center px-4 sm:px-6 lg:px-8 py-2 sm:py-3 border-2 border-[#005bb7] text-[#005bb7] hover:bg-[#005bb7] hover:text-white rounded-full text-[12px] sm:text-[13px] lg:text-[14px] xl:text-[16px] transition-all shadow-md"
              style={{ fontFamily: "Inter", fontWeight: fontWeights.inter.bold }}>Download App</a>
          )}
        </div>
      )}
    </section>
  );
}
